import { Injectable } from '@angular/core';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {Observable} from 'rxjs/Observable';

/**
 * Provides services to handle feature or project unit parameters.
 */
@Injectable()
export class ParametersService {

  constructor(private genericResourceService: GenericResourceService) {
  }

  parameterOptions(parameter): any[] {
    if (parameter
      && parameter._embedded
      && parameter._embedded.options
      && parameter._embedded.options.length > 0) {
      return parameter._embedded.options;
    } else  {
      return [];
    }
  }

  isParameterWithOptions(parameter): boolean {
    return this.parameterOptions(parameter).length > 0;
  }

  save(param, newParamValue): Observable<any> {
    let parameter;
    if (param.parameter_type === 'file') {
      parameter = {
        _links: {self: {href: param._links.self.href}},
        value: newParamValue, uploaded_file: newParamValue,
      };
    } else {
      parameter = {
        _links: {self: {href: param._links.self.href}},
        value: newParamValue, uploaded_file: null,
      };
    }

    const parentResource = this.getParentResourceUri(param);

    return this.genericResourceService
      .findServiceForResource(parameter._links.self.href)
      .save(parameter)
      .map((savedParam) => {
        if (parentResource !== null) {
          // Make sure to update the parent resource, since its api response
          // contains parameters and thus has to be updated as well
          this.genericResourceService.findServiceForResource(parentResource).refresh();
        }
        return savedParam;
      });
  }

  isFileParameter(parameter) {
    return parameter.parameter_type === 'file';
  }

  getParentResourceUri(parameter) {
    if (parameter && parameter._links && parameter._links.owning_unit) {
      return parameter._links.owning_unit.href;
    } else if (parameter && parameter._links && parameter._links.owning_service) {
      return parameter._links.owning_service.href;
    } else if (parameter && parameter._links && parameter._links.owning_port) {
      return parameter._links.owning_port.href;
    } else if (parameter && parameter._links && parameter._links.owning_evid_function) {
      return parameter._links.owning_evid_function.href;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/parameters/services/parameters.service.ts